import { Filter } from './filter.js';
export class LevelsFilter extends Filter {

    _inputMin: number;
    _inputMax: number;
    _exponent: number;
    minExponent: number;
    maxExponent: number;
    _outputMin: number;
    _outputMax: number;

    constructor(gl: any, width: number, height: number) {
        super(gl, width, height, 'levels', 'Niveaux');
        this.reset();
    }

    get inputMin() {
        return this._inputMin;
    }

    set inputMin(value) {
        var self = this;
        self._inputMin = value;
        self._touch = true;
    }

    get inputMax() {
        return this._inputMax;
    }

    set inputMax(value) {
        var self = this;
        self._inputMax = value;
        self._touch = true;
    }

    get exponent() {
        return this._exponent;
    }

    set exponent(value) {
        var self = this;
        self._exponent = value;
        self._touch = true;
    }

    get outputMin() {
        return this._outputMin;
    }

    set outputMin(value) {
        var self = this;
        self._outputMin = value;
        self._touch = true;
    }

    get outputMax() {
        return this._outputMax;
    }

    set outputMax(value) {
        var self = this;
        self._outputMax = value;
        self._touch = true;
    }

    reset() {
        var self = this;
        self._touch = true;
        self._inputMin = 0;
        self._inputMax = 255;

        self._exponent = 1.0;
        self.minExponent = 0.01;
        self.maxExponent = 9.99;

        self._outputMin = 0;
        self._outputMax = 255;
    }

}
